import { MaterialCommunityIcons } from '@expo/vector-icons';
import { FeatureName, Severity, useIsFeatureEnabled } from '@gripp/shared-logic';
import { ReactNode } from 'react';
import {
  StyleProp,
  StyleSheet,
  Text,
  TextStyle,
  TouchableOpacity,
  View,
  ViewStyle
} from 'react-native';
import { Icon } from '../../crop-circle/icons';
import { tokens } from '../../crop-circle/tokens';
import { SeverityIcons } from '../../issue/severityIcons';
import { RoutineButtonOld } from './routineButton-old';

type RoutineButtonProps = {
  onClick: () => void;
  text: string;
  buttonStyle?: StyleProp<ViewStyle>;
  buttonIcon?: Severity;
  buttonIconStyle?: StyleProp<ViewStyle>;
  labelStyle?: StyleProp<ViewStyle>;
  buttonLabelStyle?: StyleProp<TextStyle>;
  leftButtonIcon?: ReactNode;
  children?: ReactNode;
  underlineInfoText?: string;
  secondaryButtonIcon?: ReactNode;
};

export const RoutineButton = (props: RoutineButtonProps) => {
  // TODO: Crop Circle Redesign: Remove after feature is fully rolled out
  const isCropCircleRedesignEnabled = useIsFeatureEnabled(FeatureName.CropCircleRedesign);

  // TODO: Crop Circle Redesign: Remove after feature is fully rolled out
  if (!isCropCircleRedesignEnabled) {
    return <RoutineButtonOld {...props} />;
  }

  // TODO: Crop Circle Redesign: Remove to RoutineButtonBase after feature is fully rolled out
  return <RoutineButtonBase {...props} />;
}

export const RoutineButtonBase = (props: RoutineButtonProps) => {
  return (
    <TouchableOpacity
      onPress={props.onClick}
      style={[styles.button, props.buttonStyle]}
      activeOpacity={0.7}
    >
      <View style={styles.leftIconContainer}>
        {/* Status/severity icon */}
        {props.buttonIcon && (
          <MaterialCommunityIcons
            name={SeverityIcons[props.buttonIcon]}
            size={16}
            style={[styles.icon, { marginRight: 0, marginLeft: 4 }]}
          />
        )}
        
        {props.secondaryButtonIcon}
        
        {/* Left button icon (draft indicator, etc.) */}
        {props.leftButtonIcon && (
          <View style={{ marginLeft: 4 }}>{props.leftButtonIcon}</View>
        )}
      </View>

      <Text
        style={[styles.buttonLabel, props.buttonLabelStyle, props.labelStyle]}
        numberOfLines={1}
      >
        {props.text}
      </Text>
      
      {props.underlineInfoText && <Text>{props.underlineInfoText}</Text>}
      {props.children}
      
      <View style={styles.rightIconContainer}>
        <Icon name="Chevron Right" size={20} color={tokens.colors.brand.black} />
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    backgroundColor: tokens.colors.semantic.infoLight,
    borderWidth: 0,
    minHeight: 48,
    paddingHorizontal: tokens.spacing.lg,
    paddingVertical: tokens.spacing.md,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginVertical: 1,
  },
  buttonLabel: {
    ...tokens.typography.body.mediumEmphasised,
    color: tokens.colors.brand.black,
    flex: 1,
    marginLeft: tokens.spacing.sm,
  },
  icon: {
    color: tokens.colors.brand.black,
    marginRight: tokens.spacing.sm,
  },
  rightIconContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: tokens.spacing.sm,
    marginLeft: 'auto',
  },
  leftIconContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});
